export default "__VITE_ASSET__DCX9zbP$__"